import { useEffect } from "react";
import Lenis from "lenis";
import { SmoothAnchor } from "@/components/site/SmoothAnchor";
import { Header } from "@/components/site/Header";
import { Hero } from "@/components/site/Hero";
import { Marquee } from "@/components/site/Marquee";
import { Services } from "@/components/site/Services";
import { Story } from "@/components/site/Story";
import { Projects } from "@/components/site/Projects";
import { Process } from "@/components/site/Process";
import { QuoteForm } from "@/components/site/QuoteForm";
import { Footer } from "@/components/site/Footer";

export default function Home() {
  useEffect(() => {
    const lenis = new Lenis({ duration: 1.15, smoothWheel: true });
    window.__lenis = lenis;
    let id;
    const raf = (t) => { lenis.raf(t); id = requestAnimationFrame(raf); };
    id = requestAnimationFrame(raf);
    return () => { cancelAnimationFrame(id); lenis.destroy(); window.__lenis = null; };
  }, []);

  return (
    <main data-testid="home-page" className="bg-[#F8F6F0] text-[#1E1B18] overflow-x-clip">
      <SmoothAnchor />
      <Header />
      <Hero />
      <Marquee />
      <Services />
      <Story />
      <Projects />
      <Process />
      <QuoteForm />
      <Footer />
    </main>
  );
}
